// @flow
import * as React from 'react';
import TextWrapper from './Text.style';

const Text = (props: BadgeProps) => {
  const { children, className, ...rest } = props;

  return (
    <TextWrapper {...rest}>
      <p className={className}>{children}</p>
    </TextWrapper>
  );
};

export default Text;
